import { combineReducers } from 'redux'

const reducer = combineReducers({
  sample: (...x) => x
})

export default reducer



// WEBPACK FOOTER //
// ./src/reducer.js